module.exports = __webpack_public_path__ + "img/electricalTools1.png";